/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_TitleInputs */

const en_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

const fr_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatures`)
};

const es_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes`)
};

const it_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature`)
};

const nl_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitaties`)
};

const pl_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje`)
};

const fi_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemukset`)
};

const da_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgninger`)
};

const sv_applications_title = /** @type {(inputs: Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningar`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Applications_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_title = /** @type {((inputs?: Applications_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_title(inputs)
	if (locale === "fr") return fr_applications_title(inputs)
	if (locale === "es") return es_applications_title(inputs)
	if (locale === "it") return it_applications_title(inputs)
	if (locale === "nl") return nl_applications_title(inputs)
	if (locale === "pl") return pl_applications_title(inputs)
	if (locale === "fi") return fi_applications_title(inputs)
	if (locale === "da") return da_applications_title(inputs)
	if (locale === "sv") return sv_applications_title(inputs)
	return en_applications_title(inputs)
});